import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const ReturnsRefundPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4 }}>
      <Typography variant="h4" gutterBottom>
        Frakt & Returer
      </Typography>
      <Typography variant="body1" paragraph>
        Denna retur- och återbetalningspolicy ("Policy") är en del av villkoren för THAS Multitech AB ("Dolcehem"), orgnr: 559394-1957. Den beskriver rutinerna för att returnera produkter köpta från vår onlinebutik och få en återbetalning. Genom att göra ett köp accepterar du ("kund", "du", "din") att följa denna policy.
      </Typography>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          1. Berättigande för returer
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Tidsram: Du har rätt att meddela oss att du ångrar köpet inom 14 dagar från den dag du tagit emot varan. Efter att du meddelat oss har du ytterligare 14 dagar på dig att returnera varan." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Produkters skick: För att vara berättigad till full återbetalning måste produkterna vara i väsentligen oförändrat skick, i originalförpackning och utan spår av användning." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Ej returnerbara föremål: Vissa föremål är undantagna från ångerrätten, inklusive men inte begränsat till specialtillverkade varor, förseglade hygienprodukter med bruten försegling, presentkort och nedladdningsbara digitala produkter. Dessa kommer att vara tydligt markerade på vår webbplats." />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          2. Returprocess
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Initiera en retur: Kontakta vår kundtjänst på info@dolcehem.se och ange ditt ordernummer samt information om produkten du vill returnera. Du kan även använda Konsumentverkets ångerblankett." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Returfrakt: Om inget annat anges är du ansvarig för returfrakten. Om returen beror på att du fått en felaktig eller defekt vara står vi för returfrakten." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Returbehörighet: Vi rekommenderar att du kontaktar oss innan du skickar tillbaka varor, men enligt lag behöver du inte invänta särskilt 'returgodkännande' om du använder ångerrätten." />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          3. Inspektion och godkännande
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Inspektion: När vi mottagit och inspekterat returen meddelar vi dig om återbetalningen godkänns eller avslås." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Värdeminskningsavdrag: Om varan hanterats mer än nödvändigt för att fastställa dess egenskaper och funktion kan vi göra ett avdrag motsvarande värdeminskningen." />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          4. Återbetalningsprocessen
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Behandlingstid: Vid godkänd retur återbetalar vi inom 14 dagar från den dag du meddelade oss om ånger, men vi kan avvakta tills vi fått tillbaka varan eller du lämnat bevis på att den har skickats." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Återbetalningsmetod: Återbetalning sker till samma betalningsmetod som vid köpet, om inte annat överenskommits." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Omfattning: Vid ånger återbetalar vi varans pris samt standardfrakten (ej tilläggstjänster som expressfrakt)." />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          5. Utbyten
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Kontakta kundtjänst om du vill byta till en annan färg, storlek eller modell. Utbyten sker i mån av tillgång och kunden betalar eventuell retur- och ny fraktkostnad, om inte felet beror på oss." />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          6. Skadade eller defekta produkter (Reklamation)
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Tidsram: Du har 3 års reklamationsrätt enligt konsumentköplagen. Fel som upptäcks inom två månader från att du märkt felet anses alltid vara reklamerade i rätt tid." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Process: Kontakta oss på info@dolcehem.se med ditt ordernummer, en beskrivning av felet och gärna bilder." />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Åtgärd: Vid godkänd reklamation står vi för fraktkostnaderna och erbjuder reparation, ersättningsvara eller återbetalning." />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          7. Ej återbetalningsbara föremål
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="• Presentkort" />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Nedladdningsbar programvara/digitala produkter som har levererats och där ångerrätten upphört enligt lag" />
          </ListItem>
          <ListItem>
            <ListItemText primary="• Specialtillverkade varor och förseglade hygienprodukter med bruten försegling" />
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6" gutterBottom>
          8. Kontaktinformation
        </Typography>
        <Typography variant="body1">
          Kundtjänst: <strong>info@dolcehem.se</strong><br />
          Företagsnamn: THAS Multitech AB ("Dolcehem")<br />
          Organisationsnummer: 559394-1957<br />
          Adress: Stockholm, Sweden
        </Typography>
      </Box>
    </Container>
  );
};

export default ReturnsRefundPolicy;
